import type { ReactNode } from "react";

/**
 * Standard section header: a small copper eyebrow, a serif title and an
 * optional subtitle. `align="center"` for CTA bands; `tone="light"` when
 * the heading sits on a dark/forest surface.
 */
export function SectionHeading({
  eyebrow,
  title,
  subtitle,
  align = "left",
  tone = "default",
  as: Tag = "h2",
  className = "",
}: {
  eyebrow?: string;
  title: ReactNode;
  subtitle?: ReactNode;
  align?: "left" | "center";
  tone?: "default" | "light";
  as?: "h1" | "h2" | "h3";
  className?: string;
}) {
  const light = tone === "light";
  return (
    <div
      className={`max-w-2xl ${align === "center" ? "mx-auto text-center" : ""} ${className}`}
    >
      {eyebrow && (
        <p className={`eyebrow mb-3 ${light ? "text-copper-light" : ""}`}>
          {eyebrow}
        </p>
      )}
      <Tag
        className={`font-display text-3xl font-bold leading-tight sm:text-4xl ${
          light ? "text-white" : "text-bark"
        }`}
      >
        {title}
      </Tag>
      {subtitle && (
        <p
          className={`mt-3 text-base leading-relaxed sm:text-lg ${
            light ? "text-white/85" : "text-stone"
          }`}
        >
          {subtitle}
        </p>
      )}
    </div>
  );
}
